import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { LkpStoresService } from 'src/app/services/LkpStoresService';
import swal from 'sweetalert2';
import { MatDialog } from '@angular/material/dialog';
import { StoresSearchComponent } from '../stores-search/stores-search.component';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.css']
})
export class StoresComponent implements OnInit {
  strcode = '' ;
  strdesc1 = '' ;
  strdesc2 = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

  constructor(public translate: TranslateService,
              public storessrvice : LkpStoresService,
              public storage: LocalStorageService,
              public stores : LkpStoresModel,
              private dialogref: MatDialog) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }

  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  openDialog(){
    const dialogRef = this.dialogref.open(StoresSearchComponent,
      {
        data: {
          dataKey: this.stores
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.strcode = result.strcode;
        this.strdesc1 = result.strdesc1;
        this.strdesc2 = result.strdesc2;
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetriveStorese(){
     this.storessrvice.getStores(this.strcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpStoresModel) => {

        this.strdesc1 = data.strdesc1;
        this.strdesc2 = data.strdesc2;
        this.userid = data.userid;
        this.modifieddate = data.modifieddate;
        this.compcode = data.compcode;
      }
    );
  }
  submitStores(){
    if (this.strcode == '' || this.strcode == null) {
      return;
    }

    this.stores.strcode = this.strcode;
    this.stores.strdesc1 = this.strdesc1;
    this.stores.strdesc2 = this.strdesc2;

    this.stores.userid = this.storage.retrieve('stguserId');
    this.stores.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.stores.compcode = this.storage.retrieve('stgcompcode');
    this.storessrvice.AddStores(this.stores).subscribe(data => {
    this.mesgSave();
    },
      error => { alert(error); }
    );
  }
  DeleteStores(){
    this.storessrvice.DelStores(this.strcode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: LkpStoresModel) => {
      }
    );
  }
  MesgDelete(){
    swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.DeleteStores();
        swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  NewData(){
    this.strcode = '' ;
    this.strdesc1 = '' ;
    this.strdesc2 = '' ;

  }
  mesgSave() {
    swal({
    title: 'Your work has been saved',

    type: 'success',
    showConfirmButton: false,

    timer: 1500
    });
  }

}
